// taxe-commune-helpers.js — LOT TAXE 0.4 (commit D) — helpers PURS client.
//
// MIROIRS de helpers serveur (tests de parité dans taxe-commune-helpers.test.js
// — le serveur fait FOI, ne modifier l'un sans l'autre) :
//   - normalizeCommuneNom  ← lib/taxe-sejour-handlers.js (Q5)
//   - parseAddressCityCp   ← lib/migrate-kv-livret-helpers.js::parseAddress
//     (regex identique ; version allégée : pas d'overrides par logement ni
//     d'héritage lc1-lc3 — on parse le champ TEL QUE SAISI dans la fiche)
//   - hasValidBareme       ← api/sites.js::resolveBaremeTaxe (Q1 strict,
//     null ⇔ false — pilote le badge ⚠️ « Barème taxe à valider »)
//
// AUCUN import supabase ici (module pur, testable sans env) — les appels
// serveur vivent dans src/lib/taxe-api.js.

// Q5 — normalisation du nom de commune (miroir serveur).
// minuscules + strip accents (NFD) + tirets/apostrophes/underscores → espaces
// + espaces multiples unifiés. « Ramonville Saint-Agne » == « Ramonville-
// Saint-Agne » ; « L'Union » == « L Union ».
export function normalizeCommuneNom(nom) {
  if (typeof nom !== "string") return "";
  return nom
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[-_'’‐-―]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// Regex parser adresse FR : "<adresse>, <CP> <ville>" (MIROIR STRICT de
// lib/migrate-kv-livret-helpers.js::ADDRESS_REGEX).
const ADDRESS_REGEX = /^(.+?),\s*(\d{5})\s+(.+)$/;

/**
 * Parse « CP + ville » depuis une adresse complète saisie dans la fiche.
 * @param {string} adresseComplete — ex. "12 rue d'Alsace, 31000 Toulouse"
 * @returns {{city:string, postal_code:string}|null} null si non parsable
 */
export function parseAddressCityCp(adresseComplete) {
  if (!adresseComplete || typeof adresseComplete !== "string") return null;
  const match = adresseComplete.trim().match(ADDRESS_REGEX);
  if (!match) return null;
  return { city: match[3].trim(), postal_code: match[2] };
}

/**
 * Miroir CLIENT de resolveBaremeTaxe (api/sites.js, Q1 STRICT) — pilote le
 * badge ⚠️. true ⇔ le serveur produirait un devis (barème complet et valide :
 * taux ET plafond > 0 finis, précédence par champ log.taxe_sejour →
 * cfg.taxe_sejour). false ⇔ les devis publics répondent `bareme_non_valide`.
 *
 * @param {object|null} log — logement (ou chambre) du cfg
 * @param {object|null} cfg — cfg racine (barème global legacy)
 * @returns {boolean}
 */
export function hasValidBareme(log, cfg) {
  const logTs = log && typeof log.taxe_sejour === "object" ? log.taxe_sejour : null;
  const cfgTs = cfg && typeof cfg.taxe_sejour === "object" ? cfg.taxe_sejour : null;
  const pickNum = (key) => {
    for (const src of [logTs, cfgTs]) {
      if (!src) continue;
      const n = Number(src[key]);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return null;
  };
  return pickNum("taux_pct") != null && pickNum("plafond_eur") != null;
}

/**
 * Résumé lisible du barème effectif d'un logement (pour l'affichage carte
 * tarification). null si aucun barème valide (→ badge ⚠️).
 * @returns {{taux_pct:number, plafond_eur:number, mineurs_exoneres:boolean, source:'logement'|'global'}|null}
 */
export function resumeBareme(log, cfg) {
  if (!hasValidBareme(log, cfg)) return null;
  const logTs = log && typeof log.taxe_sejour === "object" ? log.taxe_sejour : null;
  const cfgTs = cfg && typeof cfg.taxe_sejour === "object" ? cfg.taxe_sejour : null;
  const pick = (key) => {
    for (const src of [logTs, cfgTs]) {
      if (!src) continue;
      const n = Number(src[key]);
      if (Number.isFinite(n) && n > 0) return n;
    }
    return null;
  };
  const pickBool = (key, fallback) => {
    for (const src of [logTs, cfgTs]) {
      if (!src) continue;
      if (typeof src[key] === "boolean") return src[key];
    }
    return fallback;
  };
  return {
    taux_pct: pick("taux_pct"),
    plafond_eur: pick("plafond_eur"),
    mineurs_exoneres: pickBool("mineurs_exoneres", true),
    source: logTs && Number(logTs.taux_pct) > 0 ? "logement" : "global",
  };
}
